import React from 'react';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import { openNewBlankWindow } from '@tencent/tencent_doc_open_url';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import Menu from '@tencent/dui/lib/components/Menu';
import styles from '@src/slide/application/service/smart-replace-image/components/image-more-info/image-more-info.less';

interface IImageMoreInfoProps {
    onPreViewClick: () => void;
    sourceUrl?: string;
    className?: string;
}

export const ImageMoreInfo = ({ sourceUrl, onPreViewClick, className = '' }: IImageMoreInfoProps) => (
    <div
        className={classNames({ [styles['info-box']]: true, [className]: !!className })}
        onClick={e => e.stopPropagation()}
    >
        <Dropdown
            alignment="right"
            dropContent={
                <Menu itemStyle={{ paddingLeft: 16 }}>
                    <Menu.Item onClick={() => onPreViewClick()}>{i18n.t('预览图片')}</Menu.Item>
                    <Menu.Item disabled={!sourceUrl} onClick={() => openNewBlankWindow(sourceUrl ?? '')}>
                        {i18n.t('查看图片来源')}
                    </Menu.Item>
                </Menu>
            }
        >
            <div className={styles.container}></div>
        </Dropdown>
    </div>
);

